import Vue from "vue";
import Router from "vue-router";
import Login from "../views/LoginView.vue";
import routeNames from "./route-names";
import routeGuards from "./route-guards";
import store from "../store";

Vue.use(Router);

var router = new Router({
  routes: [
    {
      path: "/app/:instance/set_password",
      name: routeNames.SET_PASSWORD,
      component: () => import("../views/SetPasswordView.vue"),
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
    },
    {
      path: "/app/:instance/recover",
      name: routeNames.RECOVER,
      component: () => import("../views/RecoverPasswordView.vue"),
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
    },
    {
      path: "/app/:instance/sign-up",
      name: routeNames.SELECT_SIGN_UP,
      component: () => import("../views/SignUpView.vue"),
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
    },
    {
      path: "/app/:instance/sign-up/validate/:type",
      name: routeNames.VALIDATE_TAG_OR_TICKET,
      component: () => import("../views/FindTagOrTicket.vue"),
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
    },
    {
      path: "/app/:instance/sign-up/:type/:identifier",
      name: routeNames.SIGN_UP,
      component: () => import("../views/SignUpType.vue"),
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
    },
    {
      path: "/app/:instance/sign-up/:type/",
      name: routeNames.SIGN_UP_NO_REFERENCE,
      component: () => import("../views/SignUpType.vue"),
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
    },
    {
      path: "/app/:instance/login",
      name: routeNames.LOGIN,
      component: Login,
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
    },
    {
      path: "/app/:instance",
      name: routeNames.WALLET,
      component: () => import("../views/Main.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
    },
    {
      path: "/app/:instance/invitations",
      name: routeNames.TOKENS,
      component: () => import("../views/TokensPage.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/app/:instance/my-account",
      name: routeNames.MY_ACCOUNT,
      component: () => import("../views/MyAccount.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
    },
    {
      path: "/app/:instance/my-account/user",
      name: routeNames.USER,
      component: () => import("../views/UserPage.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
    },
    {
      path: "/app/:instance/my-account/change-password",
      name: routeNames.CHANGE_PASSWORD,
      component: () => import("../views/ChangePassword.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
    },
    {
      path: "/app/:instance/balance-refund",
      name: routeNames.BALANCE_REFUND,
      component: () => import("../views/BalanceRefund.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
    },
    {
      path: "/app/:instance/recharge",
      name: routeNames.RECHARGE,
      component: () => import("../views/Recharge.vue"),
    },
    {
      path: "/app/:instance/recharge-payment",
      name: routeNames.RECHARGE_PAYMENT,
      component: () => import("../views/RechargePayment.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/app/:instance/mercadopago",
      name: routeNames.MERCADOPAGO,
      component: () => import("../views/PaymentMercadopago.vue"),
      beforeEnter: (to, from, next) => routeGuards.paymentGuard(to, from, next),
    },
    {
      path: "/app/:instance/payment-result",
      name: routeNames.PAYMENT_RESULT,
      component: () => import("../views/PaymentResult.vue"),
    },
    {
      path: "/app/:instance/payment-success",
      name: routeNames.PAYMENT_SUCCESS,
      component: () => import("../views/PaymentSuccessFrame.vue"),
    },
    {
      path: "/app/:instance/payment-error",
      name: routeNames.PAYMENT_ERROR,
      component: () => import("../views/PaymentError.vue"),
    },
    {
      path: "/app/:instance/discount-coupon",
      name: routeNames.DISCOUNT_COUPON,
      component: () => import("../views/DiscountCoupon.vue"),
      beforeEnter: (to, from, next) =>
        routeGuards.urlAccessGuard(to, from, next),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/app/:instance/transactions",
      name: routeNames.TRANSACTIONS,
      component: () => import("../views/Transactions.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/app/:instance/transaction",
      name: routeNames.TRANSACTION,
      component: () => import("../views/Transaction.vue"),
      beforeEnter: (to, from, next) =>
        routeGuards.urlAccessGuard(to, from, next),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/app/:instance/qr",
      name: routeNames.QR,
      component: () => import("../views/QrView.vue"),
      beforeEnter: (to, from, next) => routeGuards.authGuard(to, from, next),
    },
    {
      path: "/app/:instance/:action/success",
      name: routeNames.SUCCESS_VIEW,
      component: () => import("../views/GenericSuccessView.vue"),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/app/:instance/sign-up/success",
      name: routeNames.SUCCESS_VIEW_SIGN_UP,
      component: () => import("../views/GenericSuccessView.vue"),
      beforeEnter: (to, from, next) => routeGuards.loginGuard(to, from, next),
      props: (route) => ({
        ...route.params,
      }),
    },
    {
      path: "/not_found",
      name: routeNames.NOT_FOUND,
      component: () => import("../views/NotFound.vue"),
    },
    {
      path: "*",
      redirect: "/not_found",
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.params.instance != null) {
    store.commit("setInstanceId", to.params.instance);
  }
  if (!from.params.instance && !to.params.instance) {
    var navigation = {
      path:
        to.path || window.location.pathname != "/"
          ? window.location.pathname
          : "/app/",
      params: {
        instance: store.getters.instanceId,
      },
    };
    if (window.location.href.split("?").length > 1) {
      navigation.query = {
        token: window.location.href.split("?")[1].split("=")[1],
      };
    }
    if (navigation.params.instance) {
      to.params.instance = navigation.params.instance;
      store.commit("setInstanceId", navigation.params.instance);
    }
    next();
  } else {
    next();
  }
});

export default router;
